import { reactMount } from '@/lib/reactMount'
import { useRef } from 'react'
import { Button } from '@/components/Button'
import { ArrowRight } from '@/components/Icons'

export const rteBlock = ({ dataset, umbraco, version = 'default' }) => {
  const umbracoRef = useRef(umbraco || JSON.parse(dataset.umbraco))
  umbraco ||= umbracoRef.current
  const theme = umbraco.Theme || 'light'
  const backgroundColor = umbraco.BlockBackground ? `#${umbraco.BlockBackground}` : '#ffffff'

  // Button logic matching standaloneCtaBlock pattern
  const primary = umbraco.PrimaryButton
  const secondary = umbraco.SecondaryButton
  const tertiary = umbraco.TertiaryButton
  const hyperlink = umbraco.ButtonHyperlink

  const buttons = []

  // Primary
  if (primary) {
    buttons.push({
      ...primary,
      variant: 'primary',
      size: 'lg'
    })
  }

  // Secondary preferred over tertiary
  if (secondary) {
    buttons.push({
      ...secondary,
      variant: 'secondary',
      size: 'lg'
    })
  } else if (tertiary) {
    buttons.push({
      ...tertiary,
      variant: 'primary-alt',
      size: 'lg'
    })
  }
  // Hyperlink only if nothing else exists
  else if (hyperlink) {
    buttons.push({
      ...hyperlink,
      variant: 'link',
      size: 'lg'
    })
  }

  if (!umbraco.Summary) {
    return null
  }

  return (
    <div
      id={umbraco.AnchorTarget || undefined}
      data-theme={theme}
      className={`_block-section _RTEBlock-section ${version === 'hero-carousel' ? '!bg-transparent py-5 first:-mt-[56px] xl:first:-mt-[146px] z-20 relative mb-8 last:mb-0 last:pb-8' : 'py-10'}`}
      style={{ backgroundColor }}
    >
      <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8'>
        <div
          className={`_rte ${version === 'hero-carousel' ? 'text-default-50' : ''}`}
          dangerouslySetInnerHTML={{ __html: umbraco.Summary }}
        />
      </div>

      {buttons.length > 0 &&
        <div className='px-4 pt-8 sm:px-6 lg:px-8 isolate gap-y-2 gap-x-6 justify-center flex md:flex-row flex-wrap'>
          {buttons.map((btn, index) => (
            <Button
              key={index}
              href={btn.Url}
              target={btn.Target}
              variant={btn.variant}
              size={btn.size}
              componentName={btn.Url?.includes('#apply-dialog') ? 'RTE Block' : null}
            >
              {btn.variant === 'primary-alt'
                ? (
                  <span className='block relative pr-7'>{btn.Name} <ArrowRight className='absolute -right-0.5 top-1/2 -mt-[11px]' /></span>
                  )
                : (
                    btn.Name
                  )}
            </Button>
          ))}
        </div>}
    </div>
  )
}

reactMount('rteBlock', rteBlock)
